import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';

interface CanAssignReturn {
  canAssign: boolean;
}

export const useCanAssign = (path: string): CanAssignReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const [canAssign, setCanAssign] = useState<boolean>(false);

  useEffect(() => {
    if (isAdmin) {
      setCanAssign(true);
    } else {
      const hasAssignPermission =
        role?.permissions?.some(
          (permission: Permission) =>
            permission.resource === path && permission.action === 'assign'
        ) ?? false;
      setCanAssign(hasAssignPermission);
    }
  }, [isAdmin, path, role]);

  return { canAssign };
};
